import React from 'react';
import ReschedulingOffer from 'modules/reschedulingOffer/components/reschedulingOffer';


const ReschedulingOfferPage = ({ location }) => {
  const offerId = location.pathname.split('/')[3];

  return (
    <ReschedulingOffer offerId={ offerId } />
  );
};

export default ReschedulingOfferPage;
